import React, { type FC } from "react";
import { type ArticlePreviewType } from "~/types";
import Link from "next/link";
import { useSession } from "next-auth/react";

type MultimediaLoop = {
  articles: ArticlePreviewType[];
};

const MultimediaLoop: FC<MultimediaLoop> = ({ articles }) => {
  const session = useSession();
  const isAuthenticated = session?.status === "authenticated";
  return (
    <>
      {articles.map((article) => (
        <div
          key={`${article.post_name}`}
          className="articleWrap mt-14 flex flex-col border-t border-lightGray pt-12"
        >
          <h3 className="text-xl font-medium text-black">
            <Link
              className="entry-title serif"
              href={`/a/${article.post_name}`}
              dangerouslySetInnerHTML={{ __html: article.post_title }}
            ></Link>
          </h3>
          <div className="entry-summary !mt-2 mb-6">
            <span
              dangerouslySetInnerHTML={{
                __html: article.post_excerpt,
              }}
            />
          </div>

          {article?.meta?.audio && isAuthenticated && (
            <div className="flex w-full flex-col self-end md:w-[80%]">
              <span className="font-medium text-[#2f6574]">
                Clicca qui per ascoltare l&apos;audio
              </span>
              <div
                className="!mt-2 rounded-2xl bg-[#e5e6e7] p-2"
                data-placeholder_class_index="1"
              >
                <iframe
                  data-category="marketing"
                  data-service="soundcloud"
                  data-cmplz-target="src"
                  data-src-cmplz="{post.meta.audio}&amp;color=%232f6574&amp;inverse=false&amp;auto_play=false&amp;show_user=false&amp;show_reposts=false&amp;show_teaser=false"
                  src={`${article.meta.audio}&amp;color=%232f6574&amp;inverse=false&amp;auto_play=false&amp;show_user=false&amp;show_reposts=false&amp;show_teaser=false`}
                  width="100%"
                  height="20"
                  frameBorder="no"
                  scrolling="no"
                ></iframe>
              </div>
            </div>
          )}
        </div>
      ))}
    </>
  );
};

export default MultimediaLoop;
